import { Outlet } from "react-router-dom";
import Page from "../../../components/PageWrapper";

export default function PassbookSalesOutlet() {
    return (
        <Page title="Passbook Sales">
            <Outlet />
        </Page>
    )
}